document.documentElement.classList.add('jrb-js');

document.addEventListener('DOMContentLoaded', () => {
  const variantOptions = [...document.querySelectorAll('[data-jrb-variant-option]')];
  const price = document.querySelector('[data-jrb-price]');
  const addButton = document.querySelector('[data-jrb-add]');
  const updateVariant = (option) => {
    if (!option || !price || !addButton) return;
      price.innerHTML = option.dataset.compare
        ? `${option.dataset.price} <s>${option.dataset.compare}</s>`
        : option.dataset.price;
      addButton.disabled = option.dataset.available !== 'true';
      addButton.textContent = option.dataset.available === 'true' ? 'Add to bag' : 'Sold out';
      if (option.dataset.image) {
        const image = document.querySelector(`[data-media-id="${option.dataset.image}"]`);
        image?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
  };
  variantOptions.forEach((option) => option.addEventListener('change', () => updateVariant(option)));

  document.querySelectorAll('[data-jrb-quantity]').forEach((quantity) => {
    const input = quantity.querySelector('input[type="number"]');
    if (!input) return;
    quantity.addEventListener('click', (event) => {
      const button = event.target.closest('button[name="minus"],button[name="plus"]');
      if (!button) return;
      event.preventDefault();
      const minimum = Number(input.min || 1);
      const maximum = input.max ? Number(input.max) : Number.POSITIVE_INFINITY;
      const step = Number(input.step || 1);
      const current = Number(input.value || minimum);
      input.value = String(Math.min(maximum, Math.max(minimum, current + (button.name === 'plus' ? step : -step))));
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  document.querySelectorAll('.jrb-mobile-group').forEach((group) => {
    group.addEventListener('toggle', () => {
      if (!group.open) return;
      group.parentElement?.querySelectorAll('.jrb-mobile-group[open]').forEach((peer) => {
        if (peer !== group) peer.removeAttribute('open');
      });
    });
  });

  const mobileMenu = document.querySelector('[data-jrb-mobile-menu]');
  if (mobileMenu) {
    mobileMenu.addEventListener('toggle', () => {
      mobileMenu.querySelector(':scope > summary')?.setAttribute('aria-expanded', mobileMenu.open ? 'true' : 'false');
    });
  }

  document.querySelectorAll('[data-jrb-mobile-menu] a').forEach((link) => {
    link.addEventListener('click', () => mobileMenu?.removeAttribute('open'));
  });

  const heroSlides = [...document.querySelectorAll('[data-jrb-hero-slide]')];
  let heroIndex = 0;
  const showHero = (nextIndex) => {
    if (!heroSlides.length) return;
    heroIndex = (nextIndex + heroSlides.length) % heroSlides.length;
    heroSlides.forEach((slide, index) => {
      slide.classList.toggle('is-active', index === heroIndex);
      slide.setAttribute('aria-hidden', index === heroIndex ? 'false' : 'true');
    });
  };
  document.querySelector('[data-jrb-hero-prev]')?.addEventListener('click', () => showHero(heroIndex - 1));
  document.querySelector('[data-jrb-hero-next]')?.addEventListener('click', () => showHero(heroIndex + 1));
});
